module.exports = __webpack_public_path__ + "static/custom_checkout_page_es-6ecbba4e6e162cbef70636cd78dfe1b3.png";